import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip, Input } from "../../revvComponents";

import { DateSelect, ReactSelect, ErrorMessages } from "../../commonComponents";

export const prepareInitialValues = (constValues, formCompState) => {
  constValues.quoteName = formCompState.quoteName;
  if (formCompState.selectedPriceListID !== 0) {
    constValues.selectedPriceListID = formCompState.selectedPriceListID;
  }
  return { ...constValues };
};

const findSelectedOption = (id, options) =>
  options.find(option => option.id === id);

export const createForm = (formProps, json, otherProps) => {
  const { handleChange, handleBlur, handleChangeByName, messages, values } =
    formProps;
  const form = json.map(field => {
    const {
      label,
      name,
      placeholder,
      type,
      required,
      // defaultVal,
      classes,
      errorClassName,
      // visibility,
      disabled,
      tooltipText,
    } = field;
    switch (type) {
      case "text":
        return (
          <div className={`revv-form-items ${classes}`}>
            <span className="revvform-label">
              {label}
              {required && <span className="requiredwitherr-input">*</span>}
            </span>
            <Input
              id={name}
              name={name}
              type="text"
              placeholder={placeholder}
              onChange={value => handleChange(value)}
              onBlur={value => handleBlur(value)}
              value={values[name]}
              disabled={disabled}
              className={`${messages[name] ? errorClassName : ""}`}
              data-test="createquotepopup-methods-text-input"
            />
            {messages[name] && (
              <ErrorMessages messages={messages[name].required} />
            )}
          </div>
        );
      case "select":
        return (
          <div className={`revv-form-items ${classes}`}>
            <span className="revvform-label">
              {label}
              {required && <span className="requiredwitherr-input">*</span>}
            </span>
            <div className="dateselect">
              <ReactSelect
                className=""
                isSearchable
                onChange={value => handleChangeByName(value.id, name)}
                options={otherProps[`${name}SelectOptions`]}
                value={findSelectedOption(
                  values[name],
                  otherProps[`${name}SelectOptions`],
                )}
                valueKey="name"
                placeholder={placeholder}
                data-test="createquotepopup-methods-reactselect"
              />
            </div>
            {messages[name] && (
              <ErrorMessages messages={messages[name].required} />
            )}
          </div>
        );
      case "date":
        return (
          <div className={`revv-form-items ${classes}`}>
            <span className="revvform-label">
              {label}
              {required && <span className="requiredwitherr-input">*</span>}
              <Tooltip
                placement="top"
                overlay={tooltipText}
                align={{
                  offset: [0, 4],
                }}>
                <span className="whats-this">
                  <FontAwesomeIcon icon={["far", "question-circle"]} />
                </span>
              </Tooltip>
            </span>
            <div className="dateselect">
              <DateSelect
                passDefaultDate
                selectedDate={values[name]}
                returnValue={value => handleChangeByName(value, name)}
              />
            </div>
          </div>
        );
      default:
        return "";
    }
  });
  return form;
};
